import * as Sentry from "@sentry/browser";
import { BrowserTracing } from "@sentry/tracing";
Sentry.init({
    dsn: APP_SENTRY_DNS || '',
    tunnel: '/sentry-tunnel',
    integrations: [new BrowserTracing()],
    environment: APP_ENV || 'unknown',
    tracesSampleRate: 0,
});

if(typeof structuredClone === 'undefined'){
    window.structuredClone = function(object){
        return JSON.parse(JSON.stringify(object));
    }
}

// Loadash
window._ = require('lodash');

// Jquery
window.$ = window.jQuery = require('jquery');

// Bootstrap
require('bootstrap');

// Select2
require('../../node_modules/select2/dist/js/select2.full');

// Axios
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Base64
window.Base64 = require('js-base64');

// MomentJS
window.moment = require('moment');

// Daterangepicker
window.daterangepicker = require('../../node_modules/daterangepicker/daterangepicker');
require('./daterangepicker_locales');

window.Vue = require('vue').default;

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

import * as SentryVue from "@sentry/vue";
SentryVue.init({
    Vue,
    dsn: APP_SENTRY_DNS || '',
    tunnel: '/sentry-tunnel',
    integrations: [new BrowserTracing()],
    environment: APP_ENV || 'unknown',
    tracesSampleRate: 0,
});